import React, { useEffect, useState } from 'react'
import { TreeSelect } from 'antd'

export function SelectTaxonomy({
  allowClear,
  lang = 'en',
  multiple = true,
  onChange,
  label,
  filterByParentIds,
  placeholder = 'Select labels',
  startsWithSlash = false,
  taxonomy = '',
  value,
  style = {},
}) {
  const [allLabels, setAllLabels] = useState([])
  const defaultSeparator = startsWithSlash ? '/' : ''
  let labels = allLabels

  if (Array.isArray(filterByParentIds)) {
    labels = allLabels
      .filter((l) => filterByParentIds.includes(l.id))
      .flatMap((label) =>
        label.children.map((l) => ({
          ...l,
          id: label.id + defaultSeparator + l.id,
        }))
      )
  }

  function mapChildren(item = {}, parent = '', separator = defaultSeparator) {
    const { name = {}, children = [], id } = item
    const fullId = `${parent}${separator}${id}`
    const title = name[lang] || fullId

    return (
      <TreeSelect.TreeNode key={fullId} value={fullId} title={title}>
        {children.map((i) => mapChildren(i, fullId, '/'))}
      </TreeSelect.TreeNode>
    )
  }

  useEffect(() => {
    loadLabels()
  }, [])
  async function loadLabels() {
    const res = await fetch(
      `/db/guillotina/taxonomies/${taxonomy}/`
    ).then((r) => r.json())
    setAllLabels(res.children || [])
  }

  return (
    <>
      {label && (
        <div style={{ fontSize: 12, color: 'grey', ...style }}>{label}</div>
      )}
      <TreeSelect
        allowClear={allowClear}
        key={labels.length}
        loading={labels.length === 0}
        onChange={onChange}
        placeholder={placeholder}
        showCheckedStrategy={TreeSelect.SHOW_CHILD}
        showSearch
        filterTreeNode={(input, node) => {
          const txt = (t) =>
            t
              .trim()
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')

          return txt(node.title).indexOf(txt(input)) >= 0
        }}
        style={{ width: '100%' }}
        treeCheckable={multiple}
        value={value}
      >
        {labels.map((i) => mapChildren(i))}
      </TreeSelect>
    </>
  )
}
